"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HelpModalActions;
(function (HelpModalActions) {
    HelpModalActions["HelpUrlsLoaded"] = "HelpUrlsLoaded";
    HelpModalActions["Opened"] = "Opened";
    HelpModalActions["Closed"] = "Closed";
})(HelpModalActions || (HelpModalActions = {}));
exports.default = HelpModalActions;
